// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArchivesFilledSvg from "@fishx/icons-svg/es/asn/ArchivesFilled";
import FishxIcon from '../components/FishxIcon';

var ArchivesFilled = function ArchivesFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArchivesFilledSvg
  }));
};

ArchivesFilled.displayName = 'ArchivesFilled';
export default React.forwardRef(ArchivesFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ArchivesFilled.js
// module id = 2009
// module chunks = 0